import React from 'react';

const PresalePrices = ({ values, currency }) => {
const precios = Array.isArray(values) ? values : [];

  return (
    <div className="preventa-container">
      <h2 className="preventa-title">🎉 PRECIOS PROMOCIONALES DE PREVENTA </h2>
      <div className="preventa-list">
        {precios.map((item, index) => (
          <div key={index} className="preventa-item">
            <span>Hasta el {item.fecha}</span>
            <span>{item.valor} {currency}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PresalePrices;
